var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmbient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    stroke: "#1677ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1236 19.6223C17.2921 19.6223 15 21.9144 15 24.8133V25.6223H15.809C18.6405 25.6223 20.9326 23.3302 20.9326 20.4313V19.6223H20.1236Z",
    fill: "#1677ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80999 18.6223C12.6415 18.6223 14.9336 20.9144 14.9336 23.8133V24.6223H14.1246C11.2931 24.6223 9.001 22.3302 9.001 19.4313V18.6223H9.80999Z",
    fill: "#1677ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6639 13.6223C13.0235 13.6223 14.9336 15.5324 14.9336 17.9482V18.6223H14.2594C11.8999 18.6223 9.98977 16.7122 9.98977 14.2965V13.6223H10.6639Z",
    fill: "#1677ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2579 14.6223C17.8984 14.6223 15.9883 16.5324 15.9883 18.9482V19.6223H16.6624C19.022 19.6223 20.9321 17.7122 20.9321 15.2965V14.6223H20.2579Z",
    fill: "#1677ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2697 10.6223C16.9101 10.6223 15 12.5324 15 14.9482V15.6223H15.6742C18.0337 15.6223 19.9438 13.7122 19.9438 11.2965V10.6223H19.2697Z",
    fill: "#1677ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3182 4.42434C13.4844 5.90925 13.2021 8.59576 14.7223 10.4731L15.1466 10.9971L15.6705 10.5728C17.5042 9.08788 17.7866 6.40137 16.2663 4.524L15.8421 4.00008L15.3182 4.42434Z",
    fill: "#1677ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6639 8.62231C13.0235 8.62231 14.9336 10.5324 14.9336 12.9482V13.6223H14.2594C11.8999 13.6223 9.98977 11.7122 9.98977 9.29647V8.62231H10.6639Z",
    fill: "#1677ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbient);
export default __webpack_public_path__ + "static/media/Ambient.1a6c77c29b640ae85df9ecff6566c828.svg";
export { ForwardRef as ReactComponent };